import adminApi from './adminAPI';

// Client para todos os endpoints administrativos de enquetes dinâmicas
// (/api/v1/admin/enquetes/*). Reaproveita a instância axios de adminAPI.js
// (já configurada com withCredentials + interceptors de erro).
export const adminEnquetesAPI = {
  // Enquetes
  async listar() {
    const { data } = await adminApi.get('/enquetes');
    return data.enquetes;
  },

  async obter(id) {
    const { data } = await adminApi.get(`/enquetes/${id}`);
    return data.enquete;
  },

  async criar({ titulo, descricao }) {
    const { data } = await adminApi.post('/enquetes', { titulo, descricao });
    return data.enquete;
  },

  async atualizar(id, campos) {
    const { data } = await adminApi.patch(`/enquetes/${id}`, campos);
    return data.enquete;
  },

  async remover(id) {
    await adminApi.delete(`/enquetes/${id}`);
  },

  async desativar(id) {
    const { data } = await adminApi.patch(`/enquetes/${id}/desativar`);
    return data.enquete;
  },

  async reativar(id) {
    const { data } = await adminApi.patch(`/enquetes/${id}/reativar`);
    return data.enquete;
  },

  // Perguntas
  async criarPergunta(enqueteId, { texto, tipo, obrigatoria, opcoes }) {
    const { data } = await adminApi.post(`/enquetes/${enqueteId}/perguntas`, {
      texto,
      tipo,
      obrigatoria,
      opcoes
    });
    return data.pergunta;
  },

  async atualizarPergunta(enqueteId, perguntaId, campos) {
    const { data } = await adminApi.patch(`/enquetes/${enqueteId}/perguntas/${perguntaId}`, campos);
    return data.pergunta;
  },

  async moverPergunta(enqueteId, perguntaId, direcao) {
    const { data } = await adminApi.patch(`/enquetes/${enqueteId}/perguntas/${perguntaId}/ordem`, { direcao });
    return data.perguntas;
  },

  async removerPergunta(enqueteId, perguntaId) {
    await adminApi.delete(`/enquetes/${enqueteId}/perguntas/${perguntaId}`);
  },

  // Opções
  async criarOpcao(enqueteId, perguntaId, texto) {
    const { data } = await adminApi.post(`/enquetes/${enqueteId}/perguntas/${perguntaId}/opcoes`, { texto });
    return data.opcoes;
  },

  async atualizarOpcao(enqueteId, perguntaId, opcaoId, texto) {
    const { data } = await adminApi.patch(`/enquetes/${enqueteId}/perguntas/${perguntaId}/opcoes/${opcaoId}`, { texto });
    return data.opcao;
  },

  async removerOpcao(enqueteId, perguntaId, opcaoId) {
    await adminApi.delete(`/enquetes/${enqueteId}/perguntas/${perguntaId}/opcoes/${opcaoId}`);
  },

  // Imagem da pergunta
  async enviarImagem(enqueteId, perguntaId, arquivo) {
    const formData = new FormData();
    formData.append('imagem', arquivo);
    const { data } = await adminApi.post(
      `/enquetes/${enqueteId}/perguntas/${perguntaId}/imagem`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data.imagem_path;
  },

  async removerImagem(enqueteId, perguntaId) {
    await adminApi.delete(`/enquetes/${enqueteId}/perguntas/${perguntaId}/imagem`);
  },

  // Imagem de capa da enquete (fundo do card na página inicial)
  async enviarImagemCapa(enqueteId, arquivo) {
    const formData = new FormData();
    formData.append('imagem', arquivo);
    const { data } = await adminApi.post(
      `/enquetes/${enqueteId}/imagem`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data.imagem_capa;
  },

  async removerImagemCapa(enqueteId) {
    await adminApi.delete(`/enquetes/${enqueteId}/imagem`);
  },

  // Variante opcional da capa recortada pra tela pequena
  async enviarImagemCapaMobile(enqueteId, arquivo) {
    const formData = new FormData();
    formData.append('imagem', arquivo);
    const { data } = await adminApi.post(
      `/enquetes/${enqueteId}/imagem-mobile`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data.imagem_capa_mobile;
  },

  async removerImagemCapaMobile(enqueteId) {
    await adminApi.delete(`/enquetes/${enqueteId}/imagem-mobile`);
  },

  // Fundo personalizado da página pública da enquete (cor OU imagem, ver
  // PersonalizarFundoForm.js)
  async atualizarFundoCor(enqueteId, cor) {
    const { data } = await adminApi.patch(`/enquetes/${enqueteId}/fundo-cor`, { cor });
    return data;
  },

  async enviarFundoImagem(enqueteId, arquivo) {
    const formData = new FormData();
    formData.append('imagem', arquivo);
    const { data } = await adminApi.post(
      `/enquetes/${enqueteId}/fundo-imagem`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } }
    );
    return data;
  },

  async removerFundo(enqueteId) {
    await adminApi.delete(`/enquetes/${enqueteId}/fundo`);
  }
};

export default adminEnquetesAPI;
